"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadonlyBitArrayOfLength = exports.ReadonlyBitArrayFromStr = exports.ReadonlyBitArray = void 0;
var tslib_1 = require("tslib");
var is_in_range_1 = require("../functions/numeric/is-in-range");
var CReadonlyBitArray = /** @class */ (function () {
    function CReadonlyBitArray(input) {
        this._data = new Uint8Array();
        this._isInRange = (0, is_in_range_1.isInRange)(0, -1);
        if (input !== undefined) {
            this._data = new Uint8Array(input);
            this._isInRange = (0, is_in_range_1.isInRange)(0, input.length - 1);
        }
    }
    Object.defineProperty(CReadonlyBitArray.prototype, "size", {
        get: function () {
            return this._data.length;
        },
        enumerable: false,
        configurable: true
    });
    CReadonlyBitArray.prototype.get = function (at, notSetValue) {
        if (!this._isInRange(at)) {
            return notSetValue;
        }
        else {
            return this._data[at] === 0 ? 0 : 1;
        }
    };
    CReadonlyBitArray.prototype.values = function () {
        var idx;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    idx = 0;
                    _a.label = 1;
                case 1:
                    if (!(idx < this.size)) return [3 /*break*/, 3];
                    return [4 /*yield*/, this._data[idx] === 0 ? 0 : 1];
                case 2:
                    _a.sent();
                    idx += 1;
                    return [3 /*break*/, 1];
                case 3: return [2 /*return*/];
            }
        });
    };
    CReadonlyBitArray.prototype.entries = function () {
        var idx;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    idx = 0;
                    _a.label = 1;
                case 1:
                    if (!(idx < this.size)) return [3 /*break*/, 3];
                    return [4 /*yield*/, [idx, this._data[idx] === 0 ? 0 : 1]];
                case 2:
                    _a.sent();
                    idx += 1;
                    return [3 /*break*/, 1];
                case 3: return [2 /*return*/];
            }
        });
    };
    CReadonlyBitArray.prototype.map = function (fn) {
        return (0, exports.ReadonlyBitArray)(this._data.map(function (v, i) { return fn(v === 0 ? 0 : 1, i); }));
    };
    CReadonlyBitArray.prototype.forEach = function (fn) {
        this._data.forEach(function (v, i) { return fn(v === 0 ? 0 : 1, i); });
    };
    CReadonlyBitArray.prototype.toString = function () {
        return this._data.map(function (v) { return (v === 0 ? 0 : 1); }).join('');
    };
    return CReadonlyBitArray;
}());
var ReadonlyBitArray = function (input) { return new CReadonlyBitArray(input); };
exports.ReadonlyBitArray = ReadonlyBitArray;
var ReadonlyBitArrayFromStr = function (bitstr) {
    return (0, exports.ReadonlyBitArray)(Array.from(bitstr).map(function (c) { return (c === '0' ? 0 : 1); }));
};
exports.ReadonlyBitArrayFromStr = ReadonlyBitArrayFromStr;
var ReadonlyBitArrayOfLength = function (len) {
    return (0, exports.ReadonlyBitArray)(Array.from(new Array(len)).map(function (c) { return (c === '0' ? 0 : 1); }));
};
exports.ReadonlyBitArrayOfLength = ReadonlyBitArrayOfLength;
